import React, { useState } from 'react';

import { Divider, Text } from '@sede-enterprise/shell-ds-react-framework';

import styled from 'styled-components';

import Button from '../../../../UI/Button';
import { Modal } from '../../../../UI/Modal';
import { sendNotification } from '../../../../UI/Notification';
import {
  DELETE_TERMINAL_MAPPINGS,
  MESSAGES,
} from '../../../../constants/FieldNominations';
import { deleteApi } from '../../../../services/GenesisApi';
import { ITerminalMapping } from '../../../../types/FieldNominations.type';
import { ModalFooter } from '../style';

const StyledContainer = styled.div`
  text-align: left;
`;

const StyledText = styled(Text)`
  color: #8f7630;
  font-weight: bold;
  margin-bottom: 10px;
`;

const StyledDetail = styled.div`
  margin-top: 10px;
`;

interface IDeleteMapping {
  open: boolean;
  onClose: () => void;
  selectedItem: ITerminalMapping | null;
  refreshData: () => void;
}

const ConfirmDeleteMapping: React.FC<IDeleteMapping> = ({
  selectedItem,
  open,
  onClose = () => {},
  refreshData = () => {},
}) => {
  const [loading, setLoading] = useState<boolean>(false);

  const deleteMapping = () => {
    setLoading(true);
    deleteApi(`${DELETE_TERMINAL_MAPPINGS}?id=${selectedItem?.id}`, {})
      .then(() => {
        sendNotification({
          type: 'success',
          message: 'Mapping Deleted Successfully!',
        });
        onClose();
        refreshData();
      })
      .catch(() => {
        sendNotification({
          type: 'error',
          message: MESSAGES.SERVER_ERROR,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const renderFooter = () => (
    <ModalFooter>
      <Button onClick={deleteMapping} loading={loading} disabled={loading}>
        Yes
      </Button>
      <Button variant='outlined' onClick={onClose}>
        Cancel
      </Button>
    </ModalFooter>
  );

  return (
    <Modal
      open={open}
      onClose={onClose}
      title='Delete Mapping'
      isDraggable
      maskClosable={false}
      footer={renderFooter()}
      width='40%'
    >
      {selectedItem && (
        <StyledContainer>
          <StyledText>
            Do you really want to delete this mapping? We recommend not to
            delete it if actual nomination records are linked to it.
          </StyledText>
          <Divider />
          <StyledDetail>
            <b>zKey:</b> {selectedItem?.zKey}
          </StyledDetail>
          <StyledDetail>
            <b>Production Field:</b> {selectedItem?.productionField}
          </StyledDetail>
          <StyledDetail>
            <b>Terminal:</b> {selectedItem?.terminal}
          </StyledDetail>
          <StyledDetail>
            <b>Sub Terminal:</b> {selectedItem?.subTerminal}
          </StyledDetail>
        </StyledContainer>
      )}
    </Modal>
  );
};

export default ConfirmDeleteMapping;
